import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {
// Pipe to transform formattedAddress field to provide only the door number and street name
  transform(value: any, args?: any): any {
    if(value){
      var val = value.toString().split(',');
      return val[0];
    }
    return null;
  }

}
